{
  "version": "1.0",
  "builder": "kaveri-generate",
  "steps": [
    {
      "id": "repo-workspace",
      "label": "Repository & Workspace",
      "sections": [
        {
          "id": "repoWorkspaceConfig",
          "title": "Repository & Workspace Configuration",
          "fields": [{ "field": "repoWorkspaceConfig" }]
        }
      ]
    }
  ],

  "options": {
    "repositories": [
      { "label": "application-interface (GitHub)", "value": "application-interface" }
    ],
    "acceptedTbrdFileTypes": ".yaml,.yml"
  },

  "defaults": {
    "repository": "application-interface"
  },

  "// apiEndpoints": "All confirmed against kaveriBackend/spriced-platform-data-management-layer/kaveri-lite: branchesApi -> RepositorySetupController.fetchBranches() (GET /spriced/platform/branches); setupApi -> RepositorySetupController.setupRepository() (POST /spriced/platform/setup, creates the branch + returns submodulePath); processDocxApi -> JavaStreamingController.streamJavaGeneration() (POST /spriced/platform/generate-java-stream, text/plain TBRD YAML in, text/event-stream generated Java class out). generateDvmApi / deamReadsApi have no matching controller in this module and are currently unused by the builder.",
  "apiEndpoints": {
    "baseUrl": "",
    "branchesApi": "/branches",
    "setupApi": "/setup",
    "processDocxApi": "/generate-java-stream",
    "generateDvmApi": "/agent/generate-dvm",
    "deamReadsApi": "/deam-reads/process"
  }
}
